/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Water_TitleInputs */

const en_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Water`)
};

const ar_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الماء`)
};

const de_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasser`)
};

const es_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agua`)
};

const fr_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eau`)
};

const it_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acqua`)
};

const ja_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水`)
};

const ko_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`물`)
};

const pt_br_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Água`)
};

const ru_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вода`)
};

const th_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`น้ำ`)
};

const tr_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su`)
};

const zh_cn_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水`)
};

const zh_tw_daily_paywall_exclusive_tree_water_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Water_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水`)
};

/**
* | output |
* | --- |
* | "Water" |
*
* @param {Daily_Paywall_Exclusive_Tree_Water_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_water_title = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Water_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Water_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_water_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_water_title(inputs)
	return zh_tw_daily_paywall_exclusive_tree_water_title(inputs)
});